export default {
  data () {
    return {
      progressMessage: null
    }
  },

  methods: {
    /**
     * Handle submit form.
     * @returns {Promise<void>}
     */
    async handleSubmit () {
      this.validate() && await this.processForm()
    },

    validate () {
      if (this.$refs.form.validate()) {
        console.log('validate')
        return true
      } else {
        return false
      }
    },

    setProgressMessage (message) {
      this.progressMessage = message
    }
  },

  watch: {
    progressMessage (value) {
      if (value) {
        this.$q.loading.show({
          message: value
        })
      } else {
        this.$q.loading.hide()
      }
    }
  }
}
